import { Route, Routes } from 'react-router-dom';
import { DocumentViewer } from '@pages/main/DocumentViewer/index.tsx';
import { Main } from '@pages/main/Main/index.tsx';

export const MainRoutes = () => {
  return (
    <Routes>
      <Route index element={<Main />} />
      <Route path=":documentId" element={<DocumentViewer />}></Route>
    </Routes>
  );
};
